import { HeroSection, FeedbackSection } from '@/components/Layout';

export const HomePage = () => {
  return (
    <>
      <HeroSection />
      <FeedbackSection />
    </>
  );
};
